import {
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  Icon,
} from "@chakra-ui/react";
import React from "react";

/**
 * Renders the primary card
 * 
 * @param {Object} props - The props of the component
 * @returns The primary card
 */
const PrimaryCard = ({ children, title, icon, action = null, ...props }) => (
  <Card variant={"primary"} {...props}>
    <CardHeader paddingY={"8px"}>
      <HStack justifyContent={"space-between"}>
        <HStack>
          {icon && (
            <Icon as={icon} boxSize={4} />
          )}
          <Heading fontSize={"16px"} fontWeight={500}>{title}</Heading>
        </HStack>
        {action}
      </HStack>
    </CardHeader>
    <CardBody>{children}</CardBody>
  </Card>
);

export default React.memo(PrimaryCard);
